import { Modal, Image } from 'antd';
import { useState } from 'react';
import './view-photo.scss';

interface IViewPhotoProps {
  photoUrl: string;
  classNameWrapper?: string;
}

const ViewPhoto = ({ photoUrl, classNameWrapper }: IViewPhotoProps) => {
  const [previewOpen, setPreviewOpen] = useState(false);

  return (
    <div className={`view-photo-wrapper ${classNameWrapper ?? ''}`}>
      <Image src={photoUrl} preview={false} onClick={() => setPreviewOpen(true)} style={{ width: '140px' }} />
      <Modal open={previewOpen} footer={null} onCancel={() => setPreviewOpen(false)}>
        <img alt="pet-img" style={{ width: '100%' }} src={photoUrl} />
      </Modal>
    </div>
  );
};

export default ViewPhoto;
